import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initMetaPixel, trackPurchase } from "./metaPixel";
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { successTranslations } from '../i18n/translations';

const Success = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  const { language } = useLanguage();
  const t = createTranslator(language, successTranslations);

  useEffect(() => {
    setTimeout(() => {
      setIsProcessing(false);
    }, 3000); // Simule un délai de traitement de 3 secondes

    setTimeout(() => {
      navigate('/'); // Redirige vers la page d'accueil après 15 secondes
    }, 8000);
  }, [navigate]);

  useEffect(() => {
    initMetaPixel();
  
    const alreadyTracked = sessionStorage.getItem("purchase_tracked_tournament");
  
    if (!alreadyTracked) {
      setTimeout(() => {
        trackPurchase("tournament");
        sessionStorage.setItem("purchase_tracked_tournament", "true");
      }, 1500);
    }
  }, []);

  
  return (
    <section className="bg-white text-black min-h-screen flex flex-col justify-center items-center">
      {isProcessing ? (
        <div className="text-center">
          <div className="spinner border-4 border-t-[#4c2f8e] border-gray-300 rounded-full h-16 w-16 mb-6 animate-spin"></div>
          <h2 className="text-2xl font-semibold text-[#4c2f8e]">{t('validation')}</h2>
          <p className="text-gray-600 mt-4">{t('registrationFinalizing')}</p>
        </div>
      ) : (
        <div className="text-center">
          <h1 className="text-4xl font-bold text-[#4c2f8e]">{t('congratulations')}</h1>
          <p className="text-lg text-gray-700 mt-4">{t('registrationConfirmed')}</p>
          <p className="text-gray-500 mt-2">{t('redirectSoon')}</p>
        </div>
      )}

      <style>{`
        .spinner {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
};

export default Success;
